import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { IAccount } from '@GFTypes/GameStoreTypes/Account';
import { processBonusData } from './BonusDataProcessor';
import { IActionResponseData } from '@GFTypes/Responses/ActionResponse';
import { GameStore } from '@GameStore/GameStore';

export const processAccountData = (data: IActionResponseData, gameStore: GameStore): IAccount => {
    const clone = structuredClone(data);

    const balance = CurrencyUtils.createCurrencyValue(clone.account.balance);
    const win = CurrencyUtils.createCurrencyValue(clone?.result?.win ?? 0);

    const account = {
        balance: balance,
        win: win,
        bonuses: processBonusData(clone.account.bonuses, gameStore),
        currency: {
            code: clone.account.currency.code,
            exponent: clone.account.currency.exponent
        }
    };

    return account;
};
